import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminShell } from './layouts/AdminShell';
import { LoginPage } from './pages/LoginPage';
import { WorkspaceListPage } from './pages/WorkspaceListPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { SystemSettingsPage } from './pages/SystemSettingsPage';
import { AnalyticsLayout } from './pages/analytics/AnalyticsLayout';
import { AdoptionPage } from './pages/analytics/AdoptionPage';
import { PaymentsPage } from './pages/analytics/PaymentsPage';
import { UsagePage } from './pages/analytics/UsagePage';
import { TrendsPage } from './pages/analytics/TrendsPage';

/**
 * Root routes:
 * - / (login) — only page accessible without auth
 * - /workspaces — list + search (protected)
 * - /workspaces/:teamId — client detail (protected)
 * - /system-settings — staff system defaults (protected)
 * - /analytics/* — Phase 2 analytics (Adoption, Payments, Usage, Trends)
 *
 * All API calls use credentials: 'include'; 401 redirects to /.
 */
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route element={<AdminShell />}>
        <Route path="/workspaces" element={<WorkspaceListPage />} />
        <Route path="/workspaces/:teamId" element={<ClientDetailPage />} />
        <Route path="/system-settings" element={<SystemSettingsPage />} />
        <Route path="/analytics" element={<AnalyticsLayout />}>
          <Route index element={<Navigate to="adoption" replace />} />
          <Route path="adoption" element={<AdoptionPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="usage" element={<UsagePage />} />
          <Route path="trends" element={<TrendsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
